module.exports = __webpack_public_path__ + "assets/img/246501.5b8c0d41.png";